import {
    getId,
    escapeHtml,
    formatBytes
} from "../../funcs";
import Backbone from "backbone";
import RowsStorage from "../../classes/storage/RowsStorage";
import Events from "../../classes/Events";
import langDictionary from "../../classes/lang/init";

const CHAT_ROOMS = RowsStorage.get("CHAT_ROOMS");
const CHAT_MESSAGES = RowsStorage.get("CHAT_MESSAGES");
const COMMENTS = RowsStorage.get("COMMENTS");

export default class ChatCounter extends Events {

    constructor() {
        super();
        this.newMessages = {};
        this.readed = {};
        this.showed = {};
        this.listenTo(system.socketClient, "chat", this.onSocketChatEvent.bind(this));

        let chatChannel = system.apps.channel("Chat");
        this.listenTo(chatChannel, "read", this.onChannelRead.bind(this));
    }

    async createTrayBarItem(trayCollection) {
        const count = await this.loadUnreadedCount();
        this.unreadedCount = count;

        trayCollection.add({
            sort: 4,
            icon: "chat",
            newCount: count
        });
        this.trayItemModel = trayCollection.find((trayModel) =>
            trayModel.get("icon") === "chat"
        );

        this.trayItemModel.on("click", this.onClickTrayItem.bind(this));
    }

    async loadUnreadedCount() {
        const models = await CHAT_ROOMS.get({
            filter: {
                unreaded: {
                    key: "UNREADED_COUNT",
                    type: "equal",
                    not: true,
                    value: "0"
                }
            },
            offset: 0,
            limit: 100,
            columns: ["ID", "UNREADED_COUNT"]
        });

        let count = 0;
        models.forEach((model) => {
            count += +model.get("UNREADED_COUNT") || 0;
        });

        return count;
    }


    onChannelRead() {
        let count = 0;
        CHAT_ROOMS.collection.each((model) => {
            count += +model.get("UNREADED_COUNT") || 0;
        });

        this.unreadedCount = count;
        this.trayItemModel.set("newCount", this.unreadedCount);
    }

    async onSocketChatEvent(event) {
        if ( event.name !== "room:newMessage" ) {
            return;
        }

        const message = event; // contains all message fields
        const roomUsersIds = (message.ROOM_USERS || []).map((userId) => +userId);
        const isForMe = roomUsersIds.includes(+system.user.id);
        if ( isForMe ) {
            await this.onSocketNewMessage(message);
        }
    }

    async onSocketNewMessage(message) {
        message = message.attributes || message;

        const id = message.id || message.ID;
        const authorId = message.ID_LIST_USER;

        if ( !this.newMessages[id] && authorId != system.user.id ) {
            this.unreadedCount++;
            this.trayItemModel.set("newCount", this.unreadedCount);
        }
        this.newMessages[id] = true;

        const chatApp = system.apps.runned.find((app) =>
            app.params.type === "Chat"
        );

        if ( chatApp
                && !chatApp.modal.isMin
                && chatApp.modal.isActiveModal()
                && chatApp.view.room.currentView?.room?.id
        ) {
            return;
        }

        const isMuted = await this.isMuted(message.ID_CHAT_ROOMS);

        if ( !isMuted ) {
            this.showNotificationMessage(message);
        }
    }

    async isMuted(roomId) {
        let cacheRoomModel = CHAT_ROOMS.collection.get(roomId);
        let hasValueInCache = cacheRoomModel && cacheRoomModel.get("IS_MUTED") != null;
        if ( !hasValueInCache ) {
            let [ freshRoomModel ] = await CHAT_ROOMS.get({
                columns: [ "IS_MUTED" ],
                filter3: [ "ID", "==", roomId ]
            });
            return freshRoomModel && freshRoomModel.get("IS_MUTED") == 1;
        }
        return cacheRoomModel.get("IS_MUTED") == 1;
    }

    showNotificationMessage(message) {
        message = message instanceof Backbone.Model ? message.attributes : message;

        if ( message.ID_LIST_USER == system.user.id ) {
            return;
        }

        if ( this.showed[message.ID] ) {
            return;
        }
        this.showed[ message.ID ] = message;

        // здохли сокеты (коммент не обновляет у чужака)
        if ( message.ID_COMMENT ) {
            // подорожник
            COMMENTS.reload();
        }

        let notificationParams = {
            isChat: true,
            message,
            title: langDictionary.get("new_chat_message_noty_title"),
            user: {
                name: escapeHtml(
                    message.LIST_USER_FULL_NAME
                        ? message.LIST_USER_FULL_NAME
                        : langDictionary.get("chat_user") + "# " + message.ID_LIST_USER
                ),
                img: message.SYS_FILES_PHOTO_URL,
                color: message.COLOR_INDEX
            },
            description: message.TEXT_HTML,
            icon: "chat",
            click: this.onClickNotification.bind(this)
        };

        if ( message.IS_FILE == 1 ) {
            notificationParams.description = `
                    <div class='NotyFile'>
                        <div class='NotyFile--icon' data-icon='${ escapeHtml(message.FILE_EXT) }'></div>
                        <div class='NotyFile--name'>${ escapeHtml(message.FILE_NAME) }</div>
                        <div class='NotyFile--size'>${ formatBytes(message.FILE_SIZE) }</div>
                    </div>
                    `;
        }

        if ( message.SYS_FILES_PHOTO_URL ) {
            notificationParams.img = message.SYS_FILES_PHOTO_URL;
        }

        if ( message.IS_SYSTEM_MESSAGE == 1 ) {
            // если системное приложение, то его текст содержит настроенный html
            notificationParams.description = message.SYSTEM_NOTY_DESCRIPTION;

            notificationParams.user.name = escapeHtml(
                message.USER_SYSTEM_ACTION_AUTHOR_FULL_NAME
                    ? message.USER_SYSTEM_ACTION_AUTHOR_FULL_NAME
                    : langDictionary.get("chat_user") + "# " + message.ID_USER_SYSTEM_ACTION_AUTHOR
            );
            notificationParams.user.color = message.USER_SYSTEM_ACTION_AUTHOR_COLOR_INDEX;
            notificationParams.user.img = message.SYS_FILES_SYSTEM_USER_AUTHOR_PHOTO_FILE_URL;

            notificationParams.title = escapeHtml(message.SYSTEM_NOTY_TITLE);

            // если смотришь в комменты, то уведомление не должно всплывать
            if (
                message.ID_COMMENT
                    && system.existsApp((app) => (
                        // форма на нужную модель
                        app.form
                        && app.form.table == message.TABLE_NAME
                        && app.form.model
                        && app.form.model.id == message.TABLE_ID

                        // октрыта вкладка комментарии
                        && app.form.elemById
                        && app.form.elemById.tabs
                        && app.form.elemById.tabs.activeTabId == "comments"
                    ))
            ) {
                return;
            }

            notificationParams.escapeHtml = false;

            if ( message.notyColor ) {
                notificationParams.color = message.notyColor;
            }
        }

        system.apps.channel("Notification").add(notificationParams);
    }

    async onClickNotification(e, model) {
        let message = model.get("message");
        if ( !message ) {
            return;
        }

        if ( message.IS_SYSTEM_MESSAGE == 1 ) {
            if ( message.TABLE_NAME && message.TABLE_ID ) {

                system.runForm({
                    table: message.TABLE_NAME,
                    id: message.TABLE_ID
                });

                return;
            }
        }

        system.apps.channel("Notification").closeNotyBy((noty) =>
            noty.model.get("icon") == "chat"
        );

        CHAT_MESSAGES.refreshGet(getId(message)); // fast fix

        await system.requireNewModules(["@chat"]);
        system.apps.run("chat", (err, chat) => {
            chat.onClickNotification(message);
        });
    }

    async onClickTrayItem() {
        await system.requireNewModules(["@chat"]);
        system.apps.run("chat");
    }

}